const STICK = 'https://oss.turingsenseai.com/1595921183440892189.png'
const EXAMPLE = 'https://oss.turingsenseai.com/1596794250941895693.png'

export const MOCK_POINTS = [
  { name: '外观', must: true, stickFigureImg: STICK, exampleImg: EXAMPLE, photoGuide: '请拍摄商品完整外观，保证主体居中清晰' },
  { name: '正面', must: true, stickFigureImg: STICK, exampleImg: EXAMPLE, photoGuide: '请正对商品正面拍摄，避免反光' },
  { name: 'logo', must: true, stickFigureImg: STICK, exampleImg: EXAMPLE, photoGuide: '请近距离拍摄 logo，保证文字清晰' },
  { name: '五金', must: false, stickFigureImg: STICK, exampleImg: EXAMPLE, photoGuide: '请拍摄五金细节' },
  { name: '内里', must: false, stickFigureImg: STICK, exampleImg: EXAMPLE, photoGuide: '请拍摄内里材质' },
  { name: '底部', must: false, stickFigureImg: STICK, exampleImg: EXAMPLE, photoGuide: '请拍摄底部全貌' },
  { name: '肩带', must: false, stickFigureImg: STICK, exampleImg: EXAMPLE, photoGuide: '请拍摄肩带细节' },
  { name: '日期码', must: false, stickFigureImg: STICK, exampleImg: EXAMPLE, photoGuide: '请近距离拍摄日期码' }
]

export const HEADER_IMAGE = EXAMPLE
export const NEWBIE_ICON = 'https://oss.turingsenseai.com/1611048313243366680.png'
export const FLASH_ON = 'https://oss.turingsenseai.com/1621505352899218372.png'
export const FLASH_OFF = 'https://oss.turingsenseai.com/1621505326805577154.png'
export const ALBUM_ICON = 'https://oss.turingsenseai.com/1621505371198581792.png'
